import React, { useState } from 'react';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { useAsync } from 'react-use';
import { get } from 'lodash';
import { PageContainer, PageView, LoaderDots } from '@tokenyico/tokeny-ui';

import { HolderService, RedemptionService, SubscriptionsService, TokenService } from 'services';
import SessionService from '../../../../../services/SessionService';
import { formActions, holderActions } from 'app/state/actions';

import DashboardOverview from './DashboardOverview';
import DashboardTokenInformation from './DashboardTokenInformation';
import DashboardTransactions from './DashboardTransactions';
import DashboardDocuments from './Confirmation/DashboardDocuments';

import './Dashboard.less';

const Loading = () => (
  <div className="_flex:center">
    <LoaderDots />
  </div>
);

const DashboardView = ({ history, setError, selectedToken, setBalances }) => {
  const [balance, setBalance] = useState(null);
  const [status, setStatus] = useState(null);
  const [subscriptions, setSubscriptions] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [jwt, setJwt] = useState('x');
  const [documents, setDocuments] = useState([]);
  const [redemptions, setRedemptions] = useState(null);
  const [valuation, setValuation] = useState([]);
  const [lastValuationDate, setLastValuationDate] = useState(null);

  useAsync(async () => {
    try {
      setIsLoading(true);
      setBalance(null);

      if (selectedToken) {
        const [balances, currentTokenHolder, tokenSubscriptions, tokenDocuments, tokenValuation] =
          await Promise.all([
            HolderService.getBalances(selectedToken.id),
            HolderService.getTokenHolder(selectedToken.id),
            SubscriptionsService.getSubscriptions(selectedToken.id),
            TokenService.getTokenDocuments({ tokenId: selectedToken.id, language: 'EN' }), //Right now, as we have only English on the Investor platform, we should show only the ones in English.
            TokenService.getTokenValuation({ tokenId: selectedToken.id }),
          ]);
        setBalances(balances);
        setBalance(get(balances, '[0]', null));
        setStatus(get(currentTokenHolder, 'status', null));
        setSubscriptions(get(tokenSubscriptions, 'items', []));
        setJwt(await SessionService.getToken());
        setDocuments(tokenDocuments.documents);
        setValuation(tokenValuation);
        if (tokenValuation.history.length > 0)
          setLastValuationDate(tokenValuation.history[0]?.date);
      }
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
    //moved this out to avoid endpoint returning 404 and skip everything else in the try/catch
    const tokenRedemptions = await RedemptionService.getRedemptions(selectedToken.id);
    setRedemptions([tokenRedemptions]);
  }, [selectedToken.id]);

  return (
    <div>
      <div className="dashboard" id="dashboard">
        <PageContainer>
          <PageView shadowDistance={2} className="_m:bottom(4) _p:x(4) _p:top(4) _p:bottom(3)">
            {isLoading ? (
              <Loading />
            ) : (
              <div>
                <DashboardOverview
                  balance={balance}
                  token={selectedToken}
                  status={status}
                  jwt={jwt}
                  subscriptions={subscriptions}
                  redemptions={redemptions}
                  history={history}
                  lastValuationDate={lastValuationDate}
                />
                <DashboardTokenInformation token={selectedToken} valuation={valuation} />
              </div>
            )}{' '}
          </PageView>

          {!isLoading && documents.length > 0 && (
            <PageView shadowDistance={2} className="_m:bottom(4) _p:x(4) _p:top(4) _p:bottom(3)">
              <DashboardDocuments documents={documents} />
            </PageView>
          )}

          {!isLoading && (
            <PageView shadowDistance={2} className="_p:bottom(4) _p:x(4) _m:bottom(5)">
              <DashboardTransactions />
            </PageView>
          )}
        </PageContainer>
      </div>
    </div>
  );
};

const mapToProps = ({ setError, setUser, holder: { user, selectedToken } }) => ({
  setError,
  selectedToken,
  user,
  setUser,
});

export default connect(mapToProps, combineActions(formActions, holderActions))(DashboardView);
